<div class="mb-2 border-0">
  <div class="card d-flex flex-row align-items-stretch border rounded-2 shadow-sm" style="min-height: 100px;">
    
    <div class="box-fixed d-flex align-items-center justify-content-center"
         [ngClass]="{
            'bg-secondary': form.formStatus?.name === 'BOZZA',
            'bg-primary': form.formStatus?.name === 'DEFINITIVO',
            'bg-danger': form.formStatus?.name === 'ANNULLATO',
            'bg-success': form.formStatus?.name === 'FIRMATO',
            'bg-light': ['BOZZA', 'DEFINITIVO', 'ANNULLATO', 'FIRMATO'].indexOf(form.formStatus?.name ?? '') === -1
         }">
          <it-icon [name]="form.formStatus?.name === 'FIRMATO' ? 'file-pdf-ext' : 'file'"
              [color]="form.formStatus?.name ? 'light' : 'primary'"
              class="me-2"></it-icon>
    </div>

    <div class="box-content flex-grow-1 ms-3 me-3 mt-1 mb-1 d-flex flex-column justify-content-center">
      <div *ngIf="form.replaced && form.formStatus?.name !== 'ANNULLATO' && form.formStatus?.name"><span [itBadge]="'secondary'" [rounded]="true">Sostituito da nuova versione</span></div>
      <div class="fw-semibold">
        {{ form.name }}
      </div>
      <div>
        <span class="text-muted me-2">Stato:</span>
        <span class="fw-semibold text-primary">
          {{ form.formStatus?.name ? form.formStatus?.name : 'NON COMPILATO' }}
        </span>
      </div>
      <div *ngIf="form.creationUserName" class="mt-1">
        <small class="text-muted">
          <span *ngIf="form.updateUserName">Ultimo aggiornamento di {{ form.updateUserName }}</span>
          <span *ngIf="form.creationUserName && !form.updateUserName">Inserito da {{ form.updateUserName }}</span>
          <span *ngIf="form.updateDate"> il {{ form.updateDate | date: 'dd/MM/yyyy HH:mm' }}</span>
          <span *ngIf="!form.updateDate"> il {{ form.creationDate | date: 'dd/MM/yyyy HH:mm' }}</span>
        </small>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-center">
      <it-dropdown [dark]="true">
        <span button></span>
        <ng-container list>
          <it-dropdown-item *ngIf="!form.replaced" (click)="selectForm()">Apri</it-dropdown-item>
          <it-dropdown-item (click)="selectFormAndPrint()">Stampa</it-dropdown-item>
          <it-dropdown-item *ngIf="form.formStatus?.code=='COMPILATO' && !authService.isOperatoreSuperUser && (!enrollementData || enrollementData?.cancellationDate || enrollementData?.result == 'KO') && !readonly" (click)="uploadAllegato()">
            Allega modulo firmato
          </it-dropdown-item>
          <it-dropdown-item *ngIf="form.formStatus?.code!='FIRMATO' && form.formStatus?.code!='ANNULLATO' && !authService.isOperatoreSuperUser && (!enrollementData || enrollementData?.cancellationDate || enrollementData?.result == 'KO') && !readonly" (click)="deleteForm()">
            Annulla
          </it-dropdown-item>
          <it-dropdown-item *ngIf="form.formStatus?.code=='FIRMATO'" (click)="downloadAttachment()">
            Download
          </it-dropdown-item>
        </ng-container>
      </it-dropdown>
    </div>
  </div>
</div>
